<template>
  <v-date-picker
    :width="'100%'"
    :model-value="dateValue"
    @update:model-value="handleDateChange"
    first-day-of-week="1"
    locale="de"
    color="primary"
    show-adjacent-months
    show-current
    :allowed-dates="isDateAllowed"
  />
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  computed: {
    // Konvertiere DD.MM.YYYY → YYYY-MM-DD (intern für Picker)
    dateValue() {
      if (!this.modelValue) return null
      const [day, month, year] = this.modelValue.split('.')
      return `${year}-${month}-${day}`
    },
  },
  methods: {

    handleDateChange(val) {
      if (!val) {
        this.$emit('update:modelValue', null)
        return
      }
      const date = new Date(val)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      this.$emit('update:modelValue', `${day}.${month}.${year}`)
    },

    isDateAllowed(date) {
      const day = new Date(date).getDay();

      if (day === 0 || day === 6) return false;

      const maxDate = new Date();
      maxDate.setMonth(maxDate.getMonth() + 3);
      if (new Date(date) > maxDate) return false;

      const varDate = this.toLocalTime(date);
      const today = this.toLocalTime(new Date());
      
      return varDate >= today;
    },

    toLocalTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
}
</script>